import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { cn } from 'utils/classNamesTailwind';

interface InPlaceErrorPlaceholderProps {
  errorDetails?: string | null;
  className?: string;
  compact?: boolean;
  testId?: string;
}

export function InPlaceErrorPlaceholder({
  errorDetails: _errorDetails = null,
  className = '',
  compact = false,
  testId = undefined,
}: InPlaceErrorPlaceholderProps) {
  return (
    <div
      className={cn('flex w-full items-center justify-center px-6 py-10', className)}
      data-testid={testId}
      role="alert"
      aria-live="polite"
    >
      <div
        className={cn(
          'flex w-full items-center justify-center gap-6',
          compact ? 'max-w-[560px]' : 'max-w-[720px]',
          'flex-col text-center sm:flex-row sm:items-start sm:text-left'
        )}
      >
        <img
          className={cn('block shrink-0 max-w-fit', compact ? 'h-24 w-24' : 'h-28 w-28')}
          src="/illustrations/ErrorGeneric.svg"
          alt="We encountered an issue"
        />
        <div className="space-y-2">
          <Typography variant="h3" sx={{ fontWeight: 700, color: 'text.primary' }}>
            <FormattedMessage id="error.in_place.header" defaultMessage="We encountered an issue." />
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            <FormattedMessage
              id="error.in_place.refresh"
              defaultMessage="Please refresh the page or try again shortly."
            />
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            <FormattedMessage
              id="error.in_place.contact"
              defaultMessage="If the problem continues, reach out to our support team at {supportEmail} for assistance."
              values={{
                supportEmail: (
                  <a className="underline" href="mailto:Support@Tradebyte.com">
                    Support@Tradebyte.com
                  </a>
                ),
              }}
            />
          </Typography>
        </div>
      </div>
    </div>
  );
}
